"use strict";

var Assign = require("object-assign");
var BaseEventEmiter = require('../BaseEventEmitter');

module.exports = {
    createNonPersistentStore: function createNonPersistentStore(Dispatcher) {
        var NonPersistentStore = Assign({}, BaseEventEmiter);

        Dispatcher.register(function (action) {
            NonPersistentStore.emit(action.actionType, action);
        });

        return NonPersistentStore;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/flux/store.js
// module id = 786
// module chunks = 0